<template>
    <ul class="container">
        <li class="header">
            <div class="image-box">
                <van-swipe :autoplay="3000" class="swipe-box">
                    <van-swipe-item v-for="(image, index) in swipeArray" :key="index">
                        <van-image 
                            class="swipe-itme"
                            lazy-load
                            :src="image"
                        />
                    </van-swipe-item>
                </van-swipe>
            </div>
            <div class="tips-box f-s-b">
                <div class="left ellipsis f-s-b">
                    <!-- <i class="iconfont iconxiaoxi icon-size"></i> -->
                    <i class="iconhebei icongonggao icon-size"></i>
                    <span>公告: </span>
                    <!-- <span>通知, 博物馆2019年11月20日闭馆</span> -->
                    <!-- <span>{{tips}}</span> -->
                    <van-notice-bar class="notice-box" :text="tips || '暂无公告'" :scrollable="!(tips === '')" />
                </div>
                <div class="right" v-if="tipsDom" v-touch:tap.prevent="lookTipsDetail">详情></div>
            </div>
        </li>

        <li class="fast-entrance">
            <div class="bg-box">
                <div class="f-s-b info-box" >
                    <!-- <div class="title">快速预约门票</div> -->
                    <div class="f-s-b btn" v-touch:tap="goToTicket">预约门票</div>
                    <!-- <div class="f-s-b btn" >预约门票</div> -->
                </div>
                <van-image 
                    class="inner-bg-box"
                    lazy-load
                    :src="imageObj.bgImage"
                />
            </div>
        </li>


        <ul class="body" :style="`color:${serveList}`" >
            <!-- 这是被隐藏的菜单模块 -->
            <!-- <li class="render-box">
                <div class="render-title g-b-500">
                    <div class="inner-box">云游海博</div>
                </div>
                <ul class="render-contaier">
                    <li 
                        v-touch:tap="pageRouter(item)"
                        class="render-item"
                        v-for="(item, index) in serveList" :key="index"
                    >
                        <van-image 
                            class="item-iamge"
                            lazy-load
                            fit="contain"
                            :src="item.image"
                        />
                        <div class="item-name">{{item.name}}</div>
                    </li>
                </ul>
            </li> -->

            <li 
                class="ticket-box"
                v-for="(item, index) in tickertList" :key="index"
                v-touch:tap="lookDetail(item)"
            >
                <van-image 
                    class="ticket-item-iamge"
                    lazy-load
                    fit="cover"
                    :src="tokenImage(item.image)"
                />
                <div class="ticket-info f-s-b">
                    <div class="ticket-name ellipsis">{{item.name}}</div>
                    <div class="">
                        <span class="ticket-price">{{item.price > 0 ? `¥${item.price}` : '免费'}}</span>
                        <span class="ticket-btn f-c" v-touch:tap.stop="nowAppointment(item)">立即预约</span>
                    </div>
                </div>
            </li>

        </ul>

        <van-tabbar 
            safe-area-inset-bottom
            v-model="active"
            active-color="#4899ff"
        >
            <van-tabbar-item 
                v-touch:tap="pageRouter(item)"
                class="tabbar-item zx-tabbar-item"
                v-for="(item, index) in tabbarList" :key="index"
            >
                <van-image 
                    class="tabbar-item-image"
                    :class="item.className"
                    lazy-load
                    fit="contain"
                    :src="item.image"
                />
                <div class="name">{{item.name}}</div>
            </van-tabbar-item>
        </van-tabbar>


        <van-popup
            v-model="show"
            round
            closeable
            class="tips-popup-box"
            position="bottom"
            :style="{ minHeight: '50%', height: '90%' }"
        >
            <!-- <div class="title g-b-500">公告</div> -->
            <!-- <div>{{tips}}</div> -->
            <div v-if="tipsDom" class="inner-content-box">
                <div class="title g-b-500">{{tips}}</div>
                <div v-html="tipsDom"></div>
            </div>
            <div v-else>暂无详情</div>
        </van-popup>

    </ul>
</template>

<script>
    import { 
        Swipe, 
        SwipeItem, 
        Tabbar,
        TabbarItem,
        Popup,
        NoticeBar,
    } from 'vant';
    import { 
        getAllExhibitionUrl,
        getAllTicketUrl,
    } from '@ticketUrl';
    import {
        getAllNewsUrl
    } from '@culturalRelicsUrl';
    import {
        tokenImage
    } from '@js/url.js';
    import http from '@js/http-ww.js';
    export default {
        data() {
            return {
                active: 2,
                tabbarList: [
                    {
                        name: '首页',
                        className: 'home-image',
                        image: require('@image/home/455.png'),
                        routerName: 'Home',
                    },
                    {
                        name: '个人中心',
                        image: require('@image/home/22.png'),
                        routerName: 'personalCenter',
                    },
                ],
                swipeArray: [
                    require('@image/home/34.png'),
                ],
                imageObj: {
                    bgImage: require('@image/home/new-icon/15.png'),
                },
                serveList: [
                    {
                        // image: require('@image/home/menpiao-4.png'),
                        image: require('@image/home/new-icon/1.png'),
                        name: '门票预约',
                        routerName: 'calendar',
                        type: 'ticket'
                    },
                    {
                        // image: require('@image/home/menpiao-5.png'),
                        image: require('@image/home/new-icon/2.png'),
                        name: '讲解预约',
                        routerName: 'explainPage',
                    },
                    {
                        // image: require('@image/home/Fill1.png'),
                        image: require('@image/home/new-icon/5.png'),
                        name: '海博堂',
                        routerName: 'haibotang',
                    },
                    {
                        // image: require('@image/home/huodong-2.png'),
                        image: require('@image/home/new-icon/4.png'),
                        name: '活动预约',
                        routerName: 'activityPage',
                    },
                    {
                        // image: require('@image/home/23.png'),
                        image: require('@image/home/new-icon/13.png'),
                        name: '海博头条',
                        routerName: 'headlines',
                    },
                    {
                        // image: require('@image/home/5.png'),
                        image: require('@image/home/new-icon/11.png'),
                        name: '虚拟海博'
                    }
                ],
                tickertList: [
                    {
                        image: require('@image/home/1233.png'),
                        name: '博物馆门票预约',
                        price: 0,
                    },
                    {
                        image: require('@image/home/452.png'),
                        name: '博物馆门票预约',
                        price: 100,
                    },
                ],
                //  固定门票对象
                ticketObj: {},
                show: false,
                tips: '',
                tipsDom: '',

                requestParams:{
                    nodeId: 170,
                    page: -1,
                    size: 1,
                }                

            }
        },
        created() {
            this.tickertList = [];
            this.getAllExhibitionList();
            this.getAllTicketList();
            this.getNews();
        },
        methods: {
            getNews(){
                this.requestParams.page++
                http.get(getAllNewsUrl, { 
                    params:{
                        ...this.requestParams
                    }
                }).then(res=>{
                    var {
                        data: {
                            page: {
                                content = []
                            }
                        }
                    } = res.data;
                    if(content.length > 0){
                        var data = content[0]
                        this.tips = data.title;
                        this.tipsDom = data.text;
                    }
                }) 
            },
            tokenImage,
            //  菜单路由跳转以及事件
            pageRouter(item){
                return ()=>{
                    switch (item.type) {
                        //  固定门票跳转
                        case 'ticket':
                            var {
                                id:ticketId,
                                isCharge = 0,
                                ticketPrice = 0,
                                name
                            } = this.ticketObj;
                            //  后台字典 isCharge === 0 免费 else 使用票价 ticketPrice
                            if(isCharge === 0){
                                ticketPrice = 0;
                            }
                            this.$store.commit('setParmas',{
                                charge: isCharge,// 是否免费
                                ticketPrice,//  门票价格
                                name,// 门票名称
                            })
                            this.$router.push({ name: item.routerName, query: { ticketId, type: 'ticket' }})
                            break;
                        default:
                            if(item.routerName) {
                                this.$router.push({ name: item.routerName })
                            }else{
                                this.$toast('暂未开放 敬请期待');
                            }
                            break;
                    }
                }
            },
            //  临展直接预约
            nowAppointment(item){
                return ()=>{
                    var {
                        id:ticketId,
                        exhibitionId,
                        isCharge = 0,
                        ticketPrice = 0,
                        name
                    } = item.rawData;
                    var tempObj = this.$store.state.tempTransmitParams || {};
                    tempObj = Object.assign(
                        tempObj,
                        {
                            charge: item.rawData.isCharge === 0 ? 0 : 1,// 是否免费
                            ticketPrice: item.rawData.price,//  门票价格
                            name: item.rawData.name,// 门票名称
                        }
                    )
                    this.$router.push({name:'calendar', query: { ticketId, eId: exhibitionId, type: 'exhibition' } })
                }
            },
            //  临展点击查看详情
            lookDetail(item){
                return ()=>{
                    const {
                        rawData:{
                            exhibitionId,
                            id: ticketId,
                        }
                    } = item;
                    this.$router.push({ name: "exhibition", query: { ticketId, exhibitionId } })
                }
            },
            getAllTicketList(){
                this.$http.get(getAllTicketUrl) 
                .then(res=>{
                    //  博物馆固定门票
                    if(res.data.length>0){
                        this.ticketObj = res.data[0]
                    }
                }) 
            },

            //  直接去日历预约界面
            goToTicket(){
                var {
                    id:ticketId,
                    isCharge = 0,
                    ticketPrice = 0,
                    name
                } = this.ticketObj;
                //  后台字典 isCharge === 0 免费 else 使用票价 ticketPrice
                if(isCharge === 0){
                    ticketPrice = 0;
                }
                this.$store.commit('setParmas',{
                    charge: isCharge,// 是否免费
                    ticketPrice,//  门票价格
                    name,// 门票名称
                })
                this.$router.push({ name: 'calendar', query: { ticketId, type: 'ticket' }})
            },

            //  临展数据
            getAllExhibitionList(){
                // 0：窗口 1：官网、2：微信 3：自助机
                this.$http.get(getAllExhibitionUrl, { params: { type: 2 } } ) 
                .then(res=>{
                    const {
                        data : array = []
                    } = res;
                    this.tickertList = [];
                    array.map(item=>{
                        this.tickertList.push({
                            // image: "http://172.16.9.51:8081"+item.image,
                            image: item.image,
                            name: item.name,
                            //  isCharge 0 ===> 是否免费
                            price: item.isCharge === 0 ? 0 : (item.price || 0),
                            rawData: item,
                        })
                    })
                }) 
            },
            lookTipsDetail(){
                this.onChangShow();
            },
            onChangShow(){
                this.show = !this.show;
            },
        },
        components: {
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Tabbar.name]: Tabbar,
            [TabbarItem.name]: TabbarItem,
            [Popup.name]: Popup,
            [NoticeBar.name]: NoticeBar,
        }
    }
</script>

<style lang="less" scoped>
    @import "./style/home-public-style.less";

    .tabbar-item{
        text-align: center;
        width: 100%;
        position: relative;
        .icon-size{
            overflow: hidden;
            &::before{
            font-size: 20px;
            }
        }
        .tabbar-item-image{
            margin-top: 3px;
            width: 20px;
            height: 20px;
        }
        .name{
            font-weight: 500;
            margin-top: 5px;
            font-size: 10px !important;
            position: absolute;
            bottom: 5px;
            left: 50%;
            transform: translateX(-50%);
        }
        .home-image{
            background-color: #ffffff;
            padding: 5px;
            border-radius: 100%;
            overflow: hidden;
            width: 35px;
            height: 35px;
            transform: translateY(-20px);
            z-index: 5;
        }
    }
    .container{
        height: ~"calc(100% - 50px)" !important;
        background-color: #f3f4fe !important;
    }
    .tips-popup-box{
        // min-height: 40%;
        padding: 40px 20px 10px;
        box-sizing: border-box;
        overflow: hidden;
        .title{
            text-align: center;
            margin-bottom: 10px;
        }
        .inner-content-box{
            height: 100%;
            overflow-y: scroll;
            overflow-x: hidden;
        }
        img{
            width: 100%;
            min-height: 200px;
        }
    }
    .header{
        .swipe-box{
            width: 100%;
            height: 100%;
            .swipe-itme{
                width: 100%;
                height: 100%;
            }
        }
        .image-box{
            height: 185px;
        }
        .tips-box{
            margin: 0 7px;
            position: relative;
            top: -23px;
            margin-bottom: -23px;
            background:rgba(11,109,176,1);
            border:2px solid rgba(78, 183, 255, 1);
            box-shadow:0px 2px 5px 0px rgba(11,109,176,0.52);
            border-radius:23px;
            font-size: 14px;
            padding: 0 18px;
            color: #ffffff;
            height: 46px;
            .notice-box{
                background-color: transparent;
                color: #ffffff;
                padding: 0;
                flex: 1;
            }
            // background:linear-gradient(270deg,rgba(32,107,148,1) 0%,rgba(14,57,91,1) 100%);
            .left{
                width: ~"calc(100% - 40px)";
            }
            .right{
                width: 40px;
                text-align: right;
                z-index: 10;
            }
            .icon-size{
                margin-right: 5px;
                &::before{
                    font-size: 15px;
                }
            }
        }
    }


    .fast-entrance{
        // border: 1px solid red;
        // margin: 5px 7px 12px;
        margin: 5px 0px 12px;
        z-index: 2;
        position: relative;
        text-align: right;
        height: auto;
        border-radius: 10px;
        top: -20px;
        // top: -60px;
        position: relative;
        // margin-bottom: -65px;
        margin-bottom: -26px;
        .bg-box{
            position: relative;
            height: auto;
            .inner-bg-box{
                width: 100%;
                vertical-align: top;
            }
            .info-box{
                text-align: center;
                flex-direction: column;
                z-index: 2;
                position: absolute;
                top: 100px;
                left: 47px;
                .title{
                    height:25px;
                    font-size:18px;
                    font-weight:500;
                    color:rgba(83,89,106,1);
                    line-height:24px;
                    margin-bottom: 14px;
                }
                .btn{
                    color: #ffffff;
                    width:67px;
                    height:26px;
                    background:rgba(72,153,255,1);
                    border-radius:13px;
                    justify-content: center;

                    // 2020-04-09 15:47:10修改 
                    width:95px;
                    height:30px;
                    background:rgba(230,108,62,1);
                    box-shadow:0px 2px 4px 0px rgba(206, 215, 205, 0.35);
                    border-radius:15px;
                    font-size:14px;
                    font-weight:bold;
                    color:rgba(255,255,255,1);

                }
            }
        }
        .goods-image{
            vertical-align: top;
            width: 95px;
            top: 0;
            z-index: 2;
            margin-right: 11px;
        }
        .goods-image-bg{
            position: absolute;
            width: 117px;
            height: 117px;
            bottom: 0;
            right: 0;
            vertical-align: top;
        }
    }

    .body{
        padding: 7px;
        box-sizing: border-box;
        background:rgba(243,244,254,1);
        .render-box{
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            border-radius: 10px;
            padding: 20px 0 0;
            // padding: 10px 0;
            background-color: #ffffff;
            margin-bottom: 12px;
            position: relative;
            overflow: hidden;
            .render-title{
                color: #606575;
                font-size: 16px;
                margin-bottom: 20px;
                .inner-box{
                    width: 25%;
                    text-align: center;
                }
            }
            .render-title{
                margin-bottom: 20px;
                font-size:16px;
                font-weight:500;
                color:rgba(96,101,117,1);
                padding-left: 15px;
                &::after{
                    content: '';
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 25%;
                    height:5px;
                    background:rgba(86,135,207,1);
                }
                &::before{
                    content: '';
                    position: absolute;
                    top: 0;
                    right: 0;
                    width: 75%;
                    height:5px;
                    background:rgba(200,229,237,1);
                }
            }

            .title{
                margin-bottom: 20px;
                font-size:16px;
                font-weight:500;
                color:rgba(96,101,117,1);
                padding-left: 15px;
            }
            .render-contaier{
                .render-item{
                    display: inline-block;
                    vertical-align: top;
                    width: 25%;
                    text-align: center;
                    margin-bottom: 20px;
                    .item-iamge{
                        width: 40px;
                        height: 40px;
                    }
                    .item-name{
                        font-size:12px;
                        font-weight:500;
                        color:rgba(122,126,132,1);
                    }
                }
            }
        }
        .ticket-box{
            box-shadow:3px 1px 6px 0px rgba(224,224,224,0.5);
            overflow: hidden;
            border-radius: 10px;
            background-color: #ffffff;
            margin-bottom: 12px;
            .ticket-item-iamge{
                height: 172px;
                width: 100%;
            }
            .ticket-info{
                padding: 12px 10px 16px;
                .ticket-name{
                    height: 31px;
                    line-height: 31px;
                    font-size:15px;
                    font-weight:500;
                    color:rgba(99,99,99,1);
                    max-width: ~"calc(100% - 140px)";
                }
                .ticket-price{
                    font-size:16px;
                    font-weight:500;
                    height: 31px;
                    line-height: 31px;
                    vertical-align: middle;
                    display: inline-block;
                    color:rgba(249,182,45,1);
                }
                .ticket-btn{
                    margin-left: 14px;
                    display: inline-flex;
                    vertical-align: middle;
                    width:91px;
                    height:31px;
                    color: #ffffff;
                    background:rgba(73,155,227,1);
                    box-shadow:0px 4px 5px 0px rgba(158,191,255,1);
                    border-radius:8px;
                    font-size:15px;
                }
            }
        }
    }
</style>